import Styles from './styles.module.css';

const Home = () => {

  return (
    <div className={Styles.download}>
      <div className={Styles.motif} aria-hidden="true" />
      <div className={Styles.motif2} aria-hidden="true" />
      <div className={Styles.inner}>
        <span className={Styles.kicker}>Get Started</span>
        <h4>まずは無料で、<br />採用活動をもっとカンタンに。</h4>
        <p>求人票の作成から学校送付、応募・選考管理まで。<br />機能や活用方法がわかる資料をご用意しています。</p>
        <a href="https://memorii-works.com/contact">
          <button>お問い合わせ</button>
        </a>
      </div>
    </div>
  );
}

export default Home;
